import _ from 'lodash-es';

/* globals Knitiv */

export default class ModalListPublishController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} MailService
	 * @param {any} Notification
	 * @param {any[]} items
	 * @param {any} options
	 */
	constructor(
		$rootScope,
		$timeout,
		$translate,
		$uibModalInstance,
		MailService,
		Notification,
		items,
		options,
	) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.MailService = MailService;
		this.Notification = Notification;
		this.formMail = undefined;
		this.items = items;
		this.options = options;
		this.mail = {
			list:      [
				{
					type:  'from',
					kid:   $rootScope.context?.profil.kid,
					name:  $rootScope.context?.profil.name,
					email: $rootScope.context?.profil.email,
					person: undefined,
				},
				{
					type:  'cc',
					kid:   $rootScope.context?.profil.kid,
					name:  $rootScope.context?.profil.name,
					email: $rootScope.context?.profil.email,
					person: undefined,
				},
			],
			body:      null,
			body_alt:  null,
			code_type: 'KEMAIL_PUBLISH',
			subject:   null,
		};

		for (const item of this.items) {
			// @ts-ignore
			// noinspection JSCheckFunctionSignatures
			this.mail.list.push({
				type: 'link_knode',
				kid:  item.kid,
				name: item.name,
			});
		}

		this.mailOptions = _.merge({
			hideFrom:    false,
			hideSubject: true,
		}, options);

		this.items = items;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 */
	removeItem(kid) {
		this.mail.list = this.mail.list.filter(
			element => element.type !== 'link_knode' || (element.type === 'link_knode' && element.kid !== kid),
		);
	}

	async send() {
		this.sending = true;

		for (const element of this.mail.list) {
			if (
				(
					element.type === 'to'
					|| element.type === 'cc'
					|| element.type === 'bcc'
				)
				&& 'person' in element
			) {
				// In the format, we need at least name and email, both strings or objects
				// @ts-ignore
				element.name = typeof element.person === 'string' ? element.person : { ...element.person };
				delete element.person;
			}
		}

		try {
			await this.MailService.send(this.mail);
			this.sending = false;
			this.$uibModalInstance.close();
		}
		catch (/** @type {any} */ error) {
			console.error(error);
			this.sending = false;
		}
	}
}
